export function getUrlWithQueryParams(url: string, params: { [key: string]: string | number }) {
  let URL = url;
  const keys = Object.keys(params);
  if (!keys.length) return URL;
  keys.forEach((key, ind) => {
    if (params[key]) URL += ind === 0 ? `?${key}=${params[key]}` : `&${key}=${params[key]}`;
  });
  return URL;
}
